<div class="global-nav-container">
  <app-global-header [sidebarMetadata]="sidebarMetadata" [hidden]="!showHeaderandFooter"></app-global-header>
  @if (globals.isBrowser) {
  <app-search-window></app-search-window>
  }
</div>
<router-outlet></router-outlet>
@if (showHeaderandFooter) {
<app-footer [ngClass]="globalFooterOffset ? '-footer-offset' : ''"></app-footer>
}
